import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Image, Rating, Icon, Dimmer, Loader } from 'semantic-ui-react';

import _ from 'lodash';
import numeral from 'numeral';
import InfluencerContextBar from '../../components/influencer-context-bar';
import TargetLink from '../../components/target-link';
import InfluencerCategoryComponent from '../../components/influencer-category';

import hasJSONAPIClient from '../../hocs/has-jsonapi-client';
import hasUserInfo from '../../hocs/has-user-info';

import CreatorProfileStats from '../../components/creator-profile-stats';


class CreatorPage extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      influencer: null,
      influencerDetails: null,
      isLoaded: false,
      isLoading: true,
      isError: false,
      adrModalOpen: false,
      selectedPlatforms: [],
      dataPermission: null,
      isLoadingPermission: true,
    };
  }

  componentDidMount() {
    const { params, jsonAPIClient, creatorId } = this.props;
    jsonAPIClient.get('creators', creatorId || params.id).then(response => {
      const resource = response.toJSONTree();
      this.setState({
        organisation: resource.organisation,
        influencer: resource,
        influencerDetails: resource,
        isLoaded: true,
        isLoading: false,
        isError: false,
      }, this.requestADRPermission);
    });
  }

  reloadDetails = async () => {
    const { jsonAPIClient } = this.props;
    const { influencerDetails } = this.state;
    const response = await jsonAPIClient.get('influencerDetails', influencerDetails.id, {
      include: ['tags'],
    });
    this.setState({
      influencerDetails: response.toJSONTree(),
    });
  }

  leftButtonCallback = () => this.context.router.push('/dashboard');

  rightButtonCallback = () => this.context.router.push('/influencer/add');

  render() {
    const {
      influencer,
      assessment,
      isLoading,
    } = this.state;

    const tiktokIconStyle = {
      width: 15,
      marginTop: 2,
    };

    const { asModal, onBackClick } = this.props;
    if (!influencer) return null;
    const {
      name,
      thumbnail,
      primarySocialHandle,
      facebookCount,
      instagramCount,
      twitterCount,
      youtubeCount,
      facebook,
      instagram,
      twitter,
      youtube,
      twitch,
      twitchCount,
      tiktok,
      tiktokCount,
      telegramUser,
    } = influencer;

    let youtubeSlug;
    if (youtube) {
      const idRegEx = /^UC([a-zA-Z0-9_-]{22})$/;
      const isChannelId = yt => yt.match(idRegEx);
      youtubeSlug = isChannelId(youtube) ? `channel/${youtube}` : `user/${youtube}`;
    }

    const commaFormat = num => {
      const format = num > 1000000 ? '0.0a' : '0a';
      return numeral(num).format(format);
    };

    const proxyInfluencer = {
      youtubeCount,
      facebookCount,
      instagramCount,
      twitterCount,
    };
    return (
      <div className={!asModal ? 'page' : ''}>
        {isLoading && <div style={{ height: '60vh', width: '100%' }}>
          <Dimmer active inverted>
            <Loader indeterminate>Loading</Loader>
          </Dimmer>
        </div>}
        <InfluencerContextBar
          rightButtonCallback={this.rightButtonCallback}
          leftButtonCallback={this.leftButtonCallback}
          leftButtonLabel="Create A Campaign"
          rightButtonLabel="Add An Influencer"
          onBackClick={onBackClick}
          title="Back"
        />
        <div className={`${!asModal ? 'page-hero' : ''} flex no-border`}>
          <div className="item">
            <Image src={thumbnail} alt={name} size="tiny" shape="circular" spaced="right" />
          </div>
          <div className="space">
            <h2>
              {name}&nbsp;&nbsp;<span className="light">{primarySocialHandle}</span>
            </h2>
            <div className="spacer small" />
            <Rating icon="star" rating={assessment} maxRating={5} disabled />
          </div>
          <div className="item">
            <div className="flex">
              <div className="space align-center">
                <TargetLink
                  href={`https://www.facebook.com/${facebook}`}
                  renderIf={Boolean(facebook)}
                >
                  <img src="/icons/facebook.svg" alt="Facebook" />
                  { facebook && <p className="light">{commaFormat(facebookCount)}</p>}
                  { !facebook && <p className="light"><Icon name="close" color="grey" /></p>}
                </TargetLink>
              </div>
              <div className="space align-center">
                <TargetLink
                  href={`https://www.instagram.com/${instagram}`}
                  renderIf={Boolean(instagram)}
                >
                  <img src="/icons/instagram.svg" alt="Instagram" />
                  { instagram && <p className="light">{commaFormat(instagramCount)}</p>}
                  { !instagram && <p className="light"><Icon name="close" color="grey" /></p>}
                </TargetLink>
              </div>
              <div className="space align-center">
                <TargetLink
                  href={`https://www.twitter.com/${twitter}`}
                  renderIf={Boolean(twitter)}
                >
                  <img src="/icons/twitter.svg" alt="Twitter" />
                  { twitter && <p className="light">{commaFormat(twitterCount)}</p>}
                  { !twitter && <p className="light"><Icon name="close" color="grey" /></p>}
                </TargetLink>
              </div>
              <div className="space align-center">
                <TargetLink
                  href={`https://www.youtube.com/${youtubeSlug}`}
                  renderIf={Boolean(youtube)}
                >
                  <img src="/icons/youtube.svg" alt="YouTube" />
                  { youtube && <p className="light">{commaFormat(youtubeCount)}</p>}
                  { !youtube && <p className="light"><Icon name="close" color="grey" /></p>}
                </TargetLink>
              </div>

              <div className="space align-center">
                <TargetLink
                  href={`https://www.twitch.com/${twitch}`}
                  renderIf={Boolean(twitch) && twitchCount}
                >
                  <Icon name="twitch" color="purple" />
                  { twitch && <p className="light">{commaFormat(twitchCount)}</p>}
                  { !twitch && <p className="light"><Icon name="close" color="grey" /></p>}
                </TargetLink>
              </div>
              <div className="space align-center">
                <TargetLink
                  href={`https://www.tiktok.com/@${tiktok}`}
                  renderIf={Boolean(tiktok)}
                >
                  <img style={tiktokIconStyle} src="https://app.dyzio.co/logos/tiktok-logo.svg" alt="Tiktok" />
                  { tiktok && <p className="light">{commaFormat(tiktokCount)}</p>}
                  { !tiktok && <p className="light"><Icon name="close" color="grey" /></p>}
                </TargetLink>
              </div>
              <div className="space align-center">
                <TargetLink
                  href={`https://www.facebook.com/${facebook}`}
                  renderIf={false}
                >
                  <Icon name="telegram" color="blue" />
                  { telegramUser && <p className="light"><Icon name="check circle" color="green" /></p>}
                  { !telegramUser && <p className="light"><Icon name="close" color="grey" /></p>}
                </TargetLink>
              </div>
              <div className="space" />
              <div className="item align-center">
                <p><b>Category</b></p>
                <InfluencerCategoryComponent influencer={proxyInfluencer} />
              </div>
            </div>
          </div>
        </div>

        {influencer && <CreatorProfileStats influencer={influencer} asModal={asModal} />}
      </div>
    );
  }
}

CreatorPage.propTypes = {
  params: PropTypes.object.isRequired,
  jsonAPIClient: PropTypes.object.isRequired,
  asModal: PropTypes.bool,
};
CreatorPage.defaultProps = {
  asModal: false,
};

export default compose(
  hasJSONAPIClient,
  hasUserInfo,
)(CreatorPage);




/** WEBPACK FOOTER **
 ** ./src/containers/creator-page/index.js
 **/